import API from "./axios";

export const settingsApi = {
  get:    ()     => API.get("/settings"),
  update: (data) => API.put("/settings", data),
  // VL % / OS % only — readable by every signed-in user (the full settings
  // above need Settings view). AuthContext falls back to it.
  pricingDefaults: () => API.get("/settings/pricing-defaults"),
};